<form>
  <!-- <div class="input-group">
    <h3 class="input-group-label">Restaurant</h3>
    <div class="input-group type-container">
      <label>
        <input type="radio" name="restaurantFilter" [checked]="model.selectedRestaurantId === model.restaurantId" (change)="selectRestaurantId($event.target.checked && model.restaurantId)" />
        <span class="custom-radio"></span>
        <span class="input-group-label">{{model.restaurantLabel}}</span>
      </label>
      <label>
        <input type="radio" name="restaurantFilter" (change)="selectRestaurantId(null)"/>
        <span class="custom-radio"></span>
        <span class="input-group-label">Tous</span>
      </label>
    </div>
  </div>
  <div class="input-group">
    <h3 class="input-group-label">Convive</h3>
    <div class="input-group type-container">
      <label>
        <input type="radio" name="conviveFilter" [checked]="model.selectedConviveId === model.conviveId" (change)="selectConviveId($event.target.checked && model.conviveId)" />
        <span class="custom-radio"></span>
        <span class="input-group-label">{{model.conviveLabel}}</span>
      </label>
      <label>
        <input type="radio" name="conviveFilter" (change)="selectConviveId(null)"/>
        <span class="custom-radio"></span>
        <span class="input-group-label">Tous</span>
      </label>
    </div>
  </div>
  <div class="input-group">
    <h3 class="input-group-label">Prestation</h3>
    <div class="input-group type-container">
      <label>
        <input type="radio" name="prestationFilter" [checked]="model.selectedPrestationId === model.prestationId" (change)="selectPrestationId(model.prestationId)" />
        <span class="custom-radio"></span>
        <span class="input-group-label">{{model.prestationLabel}}</span>
      </label>
      <label>
        <input type="radio" name="prestationFilter" (change)="selectPrestationId(null)" />
        <span class="custom-radio"></span>
        <span class="input-group-label">Tous</span>
      </label>
    </div>
  </div> -->
  <table>
    <tr>
      <td>
        <h3 class="input-group-label">Période</h3>
      </td>
      <td>
        <div class="input-group">
          <span>{{ this.model.periodeLabel }}</span>
        </div>
      </td>
    </tr>
    <tr>
      <td>
        <h3 class="input-group-label">Contrat</h3>
      </td>
      <td>
        <div class="input-group">
          <span>{{ this.model.contratLabel }}</span>
        </div>
      </td>
    </tr>
    <tr>
      <td>
        <h3 class="input-group-label">Restaurant</h3>
      </td>
      <td>
        <div class="input-group flex-end">
          <label>
            <input type="radio" name="restaurantFilter" [checked]="model.selectedRestaurantId === model.restaurantId" (change)="selectRestaurantId($event.target.checked && model.restaurantId)" />
            <span class="custom-radio"></span>
            <span class="input-group-label">{{model.restaurantLabel}}</span>
          </label>
          <label>
            <input type="radio" name="restaurantFilter" (change)="selectRestaurantId(null)" />
            <span class="custom-radio"></span>
            <span class="input-group-label">Tous</span>
          </label>
        </div>
      </td>
    </tr>
    <tr>
      <td>
        <h3 class="input-group-label">Convive</h3>
      </td>
      <td>
        <div class="input-group flex-end">
          <label *ngIf="model.conviveId != null">
            <input type="radio" name="conviveFilter" [checked]="model.selectedConviveId === model.conviveId" (change)="selectConviveId($event.target.checked && model.conviveId)" />
            <span class="custom-radio"></span>
            <span class="input-group-label">{{model.conviveLabel}}</span>
          </label>
          <label>
            <input type="radio" name="conviveFilter" [checked]="model.conviveId === null" (change)="selectConviveId(null)" />
            <span class="custom-radio"></span>
            <span class="input-group-label">Tous</span>
          </label>
        </div>
      </td>
    </tr>
    <tr>
      <td>
        <h3 class="input-group-label">Prestation</h3>
      </td>
      <td>
        <div class="input-group flex-end">
          <label *ngIf="model.prestationId != null">
            <input type="radio" name="prestationFilter" [checked]="model.selectedPrestationId === model.prestationId" (change)="selectPrestationId(model.prestationId)" />
            <span class="custom-radio"></span>
            <span class="input-group-label">{{model.prestationLabel}}</span>
          </label>
          <label>
            <input type="radio" name="prestationFilter" [checked]="model.selectedPrestationId === null" (change)="selectPrestationId(null)" />
            <span class="custom-radio"></span>
            <span class="input-group-label">Toutes</span>
          </label>
        </div>
      </td>
  </table>

  <div class="btn-row">
    <button [disabled]="isSending" class="generic-button cancel-button" (click)="close()">
      <i class="material-icons">cancel</i><span> Annuler</span>
    </button>
    <button [disabled]="isSending" class="generic-button restaurant-type-background print-button" (click)="export()">Exporter</button>
  </div>
</form>
